import { Map } from "immutable";
import { deserializeTrip } from "lib/api/records";
import fetchJSON from "lib/fetchJSON";
import { fulfilled } from "lib/promiseMiddlewareHelpers";

// Actions
export const LOAD_TRIP = "trips/LOAD_TRIP";
export const DELETE_TRIP = "trips/DELETE_TRIP";
export const BATCH_SET_VISIBILITY = "trips/BATCH_SET_VISIBILITY";
export const BATCH_DELETE = "trips/BATCH_DELETE";

// Reducer
export const reducer = (state = Map(), action = {}) => {
  switch (action.type) {
    case fulfilled(LOAD_TRIP): {
      const { payload } = action;
      return state.set(payload.trip.id, deserializeTrip(payload.trip));
    }
    default:
      return state;
  }
};

export const loadTrip = (tripId) => (dispatch, getState) => {
  // TODO: need to return if load is PENDING, not just complete, to avoid refetch
  // I'm not even sure if we want to have this logic here, since there
  // are situations where we will want to refetch trip data. This logic
  // probably belongs in the component.
  if (getState().trips.get("tripId", false)) {
    return;
  }
  dispatch({
    type: LOAD_TRIP,
    payload: fetchJSON(`/trips/${tripId}.json?apikey=x&version=2`),
  });
};

export const deleteTrip = (tripId) => ({
  type: DELETE_TRIP,
  payload: fetchJSON(`/trips/${tripId}.json`, null, { method: "DELETE" }),
  meta: { tripId },
});

export const batchSetVisibility = (ids, visibility) => ({
  type: BATCH_SET_VISIBILITY,
  payload: fetchJSON(`/trips/batch_set_visibility.json`, { trip_ids: ids, visibility: visibility }, { method: "POST" }),
});

export const batchDelete = (ids) => ({
  type: BATCH_DELETE,
  payload: fetchJSON(`/trips/batch_delete.json`, { trip_ids: ids }, { method: "POST" }),
});
